module.exports = __webpack_public_path__ + "media/images/banner1-9feab5d2e3adb64d5dce7f0d8e0be15d.jpg";